const theme = ({ palette: { error }, typography }) => ({
  error: {
    fontWeight: typography.fontWeightRegular,
    textTransform: 'none',
    color: error.dark,
    borderColor: error.dark
  },
  label: {
    marginBottom: '0px'
  }
});

export default theme;
